import React, { Component } from "react";
import Modal from "Components/smallModal/smallModal";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";
import t from "Utils/translation";

import s from "./quotaSelector.scss";
import cx from "classnames";

export default class QuotaSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      small: [
        { value: 1073741824, label: "1 GB" },
        { value: 2147483648, label: "2 GB" },
        { value: 3221225472, label: "3 GB" },
        { value: 4294967296, label: "4 GB" },
        { value: 5368709120, label: "5 GB" },
        { value: 6442450944, label: "6 GB" },
        { value: 7516192768, label: "7 GB" },
        { value: 8589934592, label: "8 GB" }
      ],
      medium: [{ value: 17179869184, label: "16 GB" }, { value: 26843545600, label: "25 GB" }],
      large: [{ value: 53687091200, label: "50 GB" }],
      xlarge: [{ value: 107374182400, label: "100 GB" }],
      isOpenModal: false
    };
  }

  openModal = () => this.setState({ isOpenModal: true });
  closeModal = () => this.setState({ isOpenModal: false });

  onClick = q => {
    if (this.props.hideUpgradeL && q.value === 53687091200) {
      this.openModal();
    } else if (this.props.hideUpgradeXL && q.value === 107374182400) {
      this.openModal();
    } else {
      this.props.onChange({ [this.props.name]: q.value });
    }
  };

  isSectionHidden = quotas => {
    if (!this.props.hidden) return false;
    let r = true;

    quotas.forEach(q => {
      if (!this.props.hidden.includes(q.value)) r = false;
    });

    return r;
  };

  render() {
    const {
      className,
      value,
      disabled,
      disabledQuotas = [],
      errors,
      hidden = [],
      hideUpgradeL,
      hideUpgradeXL
    } = this.props;
    const { small, medium, large, xlarge } = this.state;

    return (
      <div
        className={cx(className, s.quotaSelector, {
          [s.disabled]: disabled,
          [s.withErrors]: errors
        })}
      >
        {errors && (
          <div className="inputFull2">
            <WarningBanner msg={errors} color="red" />
          </div>
        )}
        <div className={s.row}>
          <div className={s.section}>
            <div className={s.sectionLabel}>{t("input.label.quoteSelector.included")}</div>
            <div className={s.sectionQuote}>
              {small.map(q =>
                hidden.includes(q.value) ? (
                  ""
                ) : (
                  <div
                    key={q.value}
                    onClick={() => this.onClick(q)}
                    className={cx(s.quota, s.x1, {
                      [s.active]: value === q.value,
                      [s.disabled]: disabledQuotas.includes(q.value)
                    })}
                  >
                    {q.label}
                  </div>
                )
              )}
            </div>
          </div>
        </div>

        <div className={s.row}>
          <div className={cx(s.section, s.sectionMedium)}>
            <div className={s.sectionLabel}>{t("input.label.quoteSelector.upgradeM")}</div>
            <div className={s.sectionQuote}>
              {medium.map(q => {
                return hidden.includes(q.value) ? (
                  ""
                ) : (
                  <div
                    key={q.value}
                    onClick={() => this.onClick(q)}
                    className={cx(s.quota, {
                      [s.active]: value === q.value,
                      [s.disabled]: disabledQuotas.includes(q.value)
                    })}
                  >
                    {q.label}
                  </div>
                );
              })}
            </div>
          </div>

          <div
            className={cx(s.section, s.sectionLarge, { [s.hidden]: this.isSectionHidden(large) })}
          >
            <div className={s.sectionLabel}>{t("input.label.quoteSelector.upgradeL")}</div>
            <div className={s.sectionQuote}>
              {large.map(q =>
                hidden.includes(q.value) ? (
                  ""
                ) : (
                  <div
                    key={q.value}
                    onClick={() => this.onClick(q)}
                    className={cx(s.quota, {
                      [s.active]: value === q.value,
                      [s.disabled]: disabledQuotas.includes(q.value)
                    })}
                  >
                    {q.label}
                  </div>
                )
              )}
            </div>
          </div>

          <div
            className={cx(s.section, s.sectionXLarge, {
              [s.hidden]: this.isSectionHidden(xlarge)
            })}
          >
            <div className={s.sectionLabel}>{t("input.label.quoteSelector.upgradeXL")}</div>
            <div className={s.sectionQuote}>
              {xlarge.map(q =>
                hidden.includes(q.value) ? (
                  ""
                ) : (
                  <div
                    key={q.value}
                    onClick={() => this.onClick(q)}
                    className={cx(s.quota, {
                      [s.active]: value === q.value,
                      [s.disabled]: disabledQuotas.includes(q.value)
                    })}
                  >
                    {q.label}
                  </div>
                )
              )}
            </div>
          </div>
        </div>
        <Modal
          title={t("modal.ugradeRequired.plan.title")}
          closeModal={this.closeModal}
          opened={this.state.isOpenModal}
        >
          <div>
            <TranslatedString>modal.ugradeRequired.quota.desc</TranslatedString>
          </div>
          <div>
            <Button onClick={this.closeModal} type="button">
              button.understood
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}
